import React, { useMemo } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { getGameImages } from '../../../core/helpers/getGameImages';

const GameBoard = observer(({ containerConfig }) => {
  const { gameBoard } = useMemo(() => {
    return getGameImages();
  }, []);
  return (
    <Container {...containerConfig} name='GameBoardContainer'>
      <Sprite anchor={0} texture={gameBoard} />
    </Container>
  );
});

export default GameBoard;
